import { render, staticRenderFns } from "./FlipCardListElement.vue?vue&type=template&id=10bc464a&scoped=true&"
import script from "./FlipCardListElement.vue?vue&type=script&lang=ts&"
export * from "./FlipCardListElement.vue?vue&type=script&lang=ts&"
import style0 from "./FlipCardListElement.vue?vue&type=style&index=0&id=10bc464a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc464a",
  null
  
)

export default component.exports